import React from 'react';
import PropTypes from 'prop-types';
import ContactCardField from './ContactCardField';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const ContactCard = ({ contact, contactFields, handleOpenViewModal }) => {
  return (
    <div className="bg-white p-4 rounded-lg shadow-lg border-2 border-gray-200 flex">
      {/* Left half: Image */}
      <div className="w-1/3 flex items-center justify-center">
        <div className="text-9xl text-gray-700">
          <AccountCircleIcon fontSize="inherit" />
        </div>
      </div>

      {/* Right half: Fields */}
      <div className="w-1/2 p-4">
        {contactFields.map((field) => (
          <ContactCardField
            key={field.key}
            field={field}
            contact={contact}
            handleOpenViewModal={handleOpenViewModal}
          />
        ))}
      </div>
    </div>
  );
};

ContactCard.propTypes = {
  contact: PropTypes.object.isRequired,
  contactFields: PropTypes.array.isRequired,
  handleOpenViewModal: PropTypes.func.isRequired,
};

export default ContactCard;
